import { Controller } from "@hotwired/stimulus"
import { readFormParams, dataJSON } from "./shared"

// Active/abstract-submission form branch: section -> allowed participation
// types cascading, plus client-side max-file-size validation. Only active
// for forms with `active_form: true` (ActiveRegistrationForm).
export default class extends Controller {
  connect() {
    this.formParams = readFormParams(this.element)
    if (!this.formParams.active_form) return

    this._onDelegatedChange = this._onDelegatedChange.bind(this)
    this.element.addEventListener("change", this._onDelegatedChange)

    this._togglePartTypes()
    this.element.querySelector(".part-type-item")?.dispatchEvent(new Event("change", { bubbles: true }))
  }

  disconnect() {
    this.element.removeEventListener("change", this._onDelegatedChange)
  }

  _onDelegatedChange(event) {
    const target = event.target
    if (target.matches(".section-item")) {
      this._togglePartTypes()
    } else if (target.matches(".part-type-item")) {
      const hidden = this.element.querySelector("#user_registration_participation_type_id")
      if (hidden) hidden.value = target.value
    } else if (target.matches("[data-max-file-size]")) {
      this._checkFileSize(target)
    }
  }

  _checkFileSize(input) {
    const maxSize = parseFloat(input.dataset.maxFileSize) * 1024 * 1024
    const fileSize = input.files[0] ? input.files[0].size : 0
    if (fileSize > maxSize) {
      alert(input.dataset.maxFileHint)
      input.value = ""
    }
  }

  _togglePartTypes() {
    const sectionItem = this.element.querySelector(".section-item")
    if (!sectionItem) return

    const sectionHidden = this.element.querySelector("#user_registration_section_id")
    if (sectionHidden) sectionHidden.value = sectionItem.value

    const enabledPartTypes = dataJSON(sectionItem, "enabledPartTypes") || {}
    const enabledVals = enabledPartTypes[sectionItem.value] || []
    const partTypeItem = this.element.querySelector(".part-type-item")
    if (!partTypeItem) return

    Array.from(partTypeItem.options).forEach((option) => {
      const disabled = !enabledVals.includes(parseInt(option.value))
      option.disabled = disabled
      option.style.display = disabled ? "none" : ""
    })
    if (!enabledVals.includes(parseInt(partTypeItem.value))) {
      partTypeItem.value = null
    }
  }
}
